import React from 'react';
import { Link } from 'gatsby'

import StarIcon from '../../assets/images/star-icon.png'
import ProjectImage1 from '../../assets/images/projects/project1.jpg'
import ProjectImage2 from '../../assets/images/projects/project2.jpg'
import ProjectImage3 from '../../assets/images/projects/project3.jpg'
import ProjectImage4 from '../../assets/images/projects/project4.jpg'
import ProjectImage5 from '../../assets/images/projects/project5.jpg'
import ProjectImage6 from '../../assets/images/projects/project6.jpg'

const RecentProjects = () => {
    return (
        <section id="oursolutions" className="projects-area bg-color pt-100 pb-70">
            <div className="container">
                <div className="section-title">
                    <span className="sub-title">
                        <img src={StarIcon} alt="image" /> AISHA
                    </span>
                    <span className="sub-title">
                        Artificial Intelligence Solutions for Healthcare Applications
                    </span>
                    <h2>Functional AI solutions to accelerate your business practice</h2>
                    <p>Explore our suite of advanced AI solutions designed to revolutionize healthcare administration & patient care.</p>
                </div>

                <div className="row">
                    <div className="col-lg-4 col-md-6">
                        <div className="single-projects-box">
                            <div className="image">
                                <img src={ProjectImage1} alt="Project" />

                                <Link to="/case-studies-details" className="link-btn">
                                    <i className='bx bx-plus'></i>
                                </Link>
                            </div>

                            <div className="content">
                                <h3>
                                    <Link to="/case-studies-details">
                                        MedPolicy Assistant
                                    </Link>
                                </h3>
                                <span>Clinical Policy & Medical Necessity Criteria Ingestion Pipeline</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-projects-box">
                            <div className="image">
                                <img src={ProjectImage2} alt="Project" />

                                <Link to="/case-studies-details" className="link-btn">
                                    <i className='bx bx-plus'></i>
                                </Link>
                            </div>

                            <div className="content">
                                <h3>
                                    <Link to="/case-studies-details">
                                        Policy Management
                                    </Link>
                                </h3>
                                <span>Zero Hallucination<br /> Compliance Chatbot</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-projects-box">
                            <div className="image">
                                <img src={ProjectImage6} alt="Project" />

                                <Link to="/case-studies-details" className="link-btn">
                                    <i className='bx bx-plus'></i>
                                </Link>
                            </div>

                            <div className="content">
                                <h3>
                                    <Link to="/case-studies-details">
                                        Clinical Documentation
                                    </Link>
                                </h3>
                                <span>HIPAA Complaint Healthcare Records Summarization System</span>
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-lg-4 col-md-6">
                        <div className="single-projects-box">
                            <div className="image">
                                <img src={ProjectImage4} alt="Project" />

                                <Link to="/case-studies-details" className="link-btn">
                                    <i className='bx bx-plus'></i>
                                </Link>
                            </div>

                            <div className="content">
                                <h3>
                                    <Link to="/case-studies-details">
                                        Detection Project
                                    </Link>
                                </h3>
                                <span>Programming</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-projects-box ">
                            <div className="image">
                                <img src={ProjectImage5} alt="Project" />

                                <Link to="/case-studies-details" className="link-btn">
                                    <i className='bx bx-plus'></i>
                                </Link>
                            </div>

                            <div className="content">
                                <h3>
                                    <Link to="/case-studies-details">
                                        Data Scientist
                                    </Link>
                                </h3>
                                <span>Data Science</span>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="single-projects-box">
                            <div className="image">
                                <img src={ProjectImage3} alt="Project" />

                                <Link to="/case-studies-details" className="link-btn">
                                    <i className='bx bx-plus'></i>
                                </Link>
                            </div>

                            <div className="content">
                                <h3>
                                    <Link to="/case-studies-details">
                                        Benefits Research
                                    </Link>
                                </h3>
                                <span>Science Projects</span>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    )
}

export default RecentProjects;